export const environment = {
  production: false,
  URL_API: 'http://34.171.247.26:3000',
  URL_API_V1: 'http://34.171.247.26:3100/v1',
  URL_SOCKET_V1: 'http://34.171.247.26:3100',
  URL_NEO4J: 'bolt://34.171.247.26:7687',
};
